/**
 * Product Gallery V2
 * Управление галереей изображений продукта с миниатюрами
 */

(function () {
if (window.ProductGalleryV2) {
  if (typeof window.initProductGalleries === 'function') {
    window.initProductGalleries();
  }
  return;
}

class ProductGalleryV2 {
  constructor(container) {
    this.container = container;
    
    // Сначала пытаемся найти по ID (самый надежный способ)
    const productInfo = this.container.closest('product-info');
    const sectionId = productInfo?.dataset.section;
    
    if (sectionId) {
      this.mainImage = document.querySelector(`#MainProductImage-${sectionId}`);
    }
    
    // Если не нашли по ID, ищем по селектору, исключая изображения в тегах
    if (!this.mainImage) {
      const allImages = this.container.querySelectorAll('.product-img img');
      // Ищем изображение, которое НЕ находится внутри .product-image-tags
      this.mainImage = Array.from(allImages).find(img => 
        !img.closest('.product-image-tags')
      );
    }
    
    this.thumbnails = this.container.querySelectorAll('.product-image-tumb-img');
    this.swipeSurface = this.container.querySelector('.product-img');
    this.touchStart = null;
    
    if (!this.mainImage) {
      console.warn('ProductGalleryV2: основное изображение не найдено');
      return;
    }
    
    this.init();
  }
  
  init() {
    if (this.thumbnails.length === 0) return;

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        this.switchImage(thumbnail);
      });
    });

    this.initSwipe();
  }

  initSwipe() {
    if (!this.swipeSurface || this.thumbnails.length < 2) return;

    this.swipeSurface.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      this.touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
    }, { passive: true });

    this.swipeSurface.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!this.touchStart || !touch) return;

      const deltaX = touch.clientX - this.touchStart.x;
      const deltaY = touch.clientY - this.touchStart.y;
      this.touchStart = null;

      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;

      const activeIndex = Array.from(this.thumbnails).findIndex((thumbnail) => thumbnail.classList.contains('active'));
      const currentIndex = activeIndex >= 0 ? activeIndex : 0;
      const nextIndex = deltaX < 0 ? currentIndex + 1 : currentIndex - 1;

      if (nextIndex >= 0 && nextIndex < this.thumbnails.length) {
        this.switchImage(this.thumbnails[nextIndex]);
      }
    }, { passive: true });

    this.swipeSurface.addEventListener('touchcancel', () => {
      this.touchStart = null;
    }, { passive: true });
  }

  switchImage(thumbnail) {
    const thumbnailImg = thumbnail.querySelector('img');
    const fullSrc = thumbnail.dataset.fullSrc || thumbnailImg?.dataset.fullSrc || thumbnailImg?.src;
    const alt = thumbnail.dataset.mediaAlt || thumbnailImg?.alt;

    if (!fullSrc) {
      console.error('ProductGalleryV2: URL изображения не найден');
      return;
    }

    // Убеждаемся, что мы работаем с правильным основным изображением
    // (не с иконками в тегах)
    if (!this.mainImage || this.mainImage.closest('.product-image-tags')) {
      // Переинициализируем поиск основного изображения
      const productInfo = this.container.closest('product-info');
      const sectionId = productInfo?.dataset.section;
      if (sectionId) {
        this.mainImage = document.querySelector(`#MainProductImage-${sectionId}`);
      }
      if (!this.mainImage) {
        const allImages = this.container.querySelectorAll('.product-img img');
        this.mainImage = Array.from(allImages).find(img => 
          !img.closest('.product-image-tags')
        );
      }
      if (!this.mainImage) {
        console.error('ProductGalleryV2: не удалось найти основное изображение');
        return;
      }
    }
    
    // Обновляем основное изображение
    if (fullSrc && this.mainImage) {
      // Добавляем плавную загрузку
      this.mainImage.style.opacity = '0.5';
      this.mainImage.style.transition = 'opacity 0.3s ease';
      
      // Удаляем srcset и sizes перед загрузкой нового изображения
      this.mainImage.removeAttribute('srcset');
      this.mainImage.removeAttribute('sizes');
      
      // Создаем новое изображение для предзагрузки
      const img = new Image();
      img.onload = () => {
        console.log('ProductGalleryV2: изображение загружено');
        // Обновляем только src
        this.mainImage.src = fullSrc;
        this.mainImage.style.opacity = '1';
      };
      img.onerror = () => {
        console.error('ProductGalleryV2: ошибка загрузки изображения', fullSrc);
        // Если загрузка не удалась, возвращаем прозрачность
        this.mainImage.style.opacity = '1';
      };
      // Начинаем загрузку изображения
      img.src = fullSrc;
      
      // Обновляем alt текст
      if (alt) {
        this.mainImage.alt = alt;
      }
    } else {
      console.error('ProductGalleryV2: нет URL изображения или основного изображения', {
        fullSrc,
        mainImage: this.mainImage
      });
    }
    
    // Обновляем активное состояние миниатюр
    this.thumbnails.forEach(thumb => {
      thumb.classList.remove('active');
      thumb.setAttribute('aria-pressed', 'false');
    });
    
    thumbnail.classList.add('active');
    thumbnail.setAttribute('aria-pressed', 'true');
  }
}

// Экспортируем класс для использования в других модулях
window.ProductGalleryV2 = ProductGalleryV2;

// Инициализация при загрузке DOM
function initProductGalleries() {
  const galleryContainers = document.querySelectorAll('.product-image-wrap');
  console.log('ProductGalleryV2: поиск контейнеров галереи, найдено:', galleryContainers.length);
  
  galleryContainers.forEach((container, index) => {
    if (container.dataset.galleryInitialized === 'true') return;
    console.log(`ProductGalleryV2: инициализация контейнера ${index}`, container);
    try {
      new ProductGalleryV2(container);
      container.dataset.galleryInitialized = 'true';
    } catch (error) {
      console.error('Ошибка инициализации галереи:', error);
    }
  });
}

window.initProductGalleries = initProductGalleries;

// Инициализация при полной загрузке DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('ProductGalleryV2: DOM загружен, инициализация галерей');
    initProductGalleries();
  });
} else {
  // Если DOM уже загружен, инициализируем сразу
  console.log('ProductGalleryV2: DOM уже загружен, инициализация галерей');
  // Небольшая задержка для гарантии, что все элементы на месте
  setTimeout(initProductGalleries, 50);
}

// Переинициализация при изменении варианта продукта
document.addEventListener('variant:change', () => {
  // Даем время на обновление DOM
  setTimeout(() => {
    initProductGalleries();
  }, 100);
});
})();
